import {
  FilterMode,
  AuthorPublisher_OrderBy,
  AuthorPublisher,
  SortOrder,
  AuthorPublisher_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const authorPublisherService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.authorPublisherOne({ id });
    return result.authorPublisherOne as AuthorPublisher;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: AuthorPublisher_OrderBy[] | null = null,
    filter: AuthorPublisher_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: AuthorPublisher_Filter | undefined;
    if (searchValue !== "") {
      where = { id: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.authorPublisherListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : { id: SortOrder.Asc },
      where,
    });
    const list = nullToUndefinedRecursive(
      result.authorPublisherListWithOffset
    ) as AuthorPublisher[];
    return { list, orderBy };
  },
};
